// https://zigarrendepotdepot.com/pages/cookiehop?kw=liquid%20life

function setCookie(){
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const kw = urlParams.get('kw')  
  const d = new Date();
  d.setTime(d.getTime() + (24*60*60*1000));
  let expires = 'expires='+ d.toUTCString();
  document.cookie = 'cookiehop='+kw+';' + expires + ";path=/";  
}

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function deleteCookie(name) {
  document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

if (window.location.href.indexOf('cookiehop') > -1) {
  setCookie();
  window.location.href = 'https://www.google.de';
}

var ccontent = getCookie('cookiehop');

if (ccontent != '' && window.location.href.indexOf('cookiehop') < 0) {
  deleteCookie('cookiehop');
  let result = window.prompt("Hallo\nDanke für deine Teinnahme?\nAn welcher Position befindet sich das Keyword in der Google Suche?","");
  const xhr = new XMLHttpRequest();
  xhr.open("GET", "https://seorch.xyz/development/ll/get.php?data="+ccontent+','+result, true);
  xhr.onload = () => {
    // Request finished. Do processing here.
  };
  xhr.send(null);
}

